import { queryOptions } from '@tanstack/react-query';
import api from '@/api/api';
import { cueingImagesResponseSchema } from '@/api/schema/images';

export const getAllImagesQueryOptions = queryOptions({
  queryKey: [ 'images' ],
  queryFn: async () => {
    const response = await api.get('images/prefetch', { timeout: 30000 });
    return cueingImagesResponseSchema.parse(await response.json());
  },
  staleTime: 1000 * 60 * 60 * 24,
});
